import './label.scss'

export const Label = {
  name:'Label',
  props: {
    title:{
      default:''
    },
    colon:{
      default:true
    },
    margin:{
      default:true
    },
    labelWidth:{
      type:[Number , String],
      default:80,
    },
    labelAlign:{
      type:String,
      default:'right'
    }
  },
  render(){
    const { $scopedSlots } = this
    const style = {}
    if( this.labelWidth ) style.width = this.labelWidth
    if( this.labelAlign ) style.textAlign = this.labelAlign
    const title = this.title
    const titleEl = 
      $scopedSlots.title ? 
        <div class="title" style={style}>{ $scopedSlots.title() }</div> : 
      title ? 
        <div class="title" style={style}>{title}</div> : 
      null
      
    return (
      <div class={['sl-form-label', !this.margin ? 'no-margin' : '', this.colon ? 'colon' : '']}>
        {titleEl}
        <div class="content">{$scopedSlots.default ? $scopedSlots.default() : null}</div>
      </div>
    )
  }
}